import * as coloursAPI from "./colours-api";

export async function getColours() {
  try {
    const response = await coloursAPI.index();
    return response;
  } catch (err) {
    return err;
  }
}

export async function createColour(data) {
  try {
    const response = await coloursAPI.create(data);
    return response;
  } catch (err) {
    return err;
  }
}

export async function updateColour(id, data) {
  try {
    const response = await coloursAPI.update(id, data);
    return response;
  } catch (err) {
    return err;
  }
}

export async function deleteColour(id) {
  try {
    const response = await coloursAPI.remove(id);
    return response;
  } catch (err) {
    return err;
  }
}
